import _get from 'lodash/get';
import { TableModuleProps } from '../';
import { SearchConfig } from '../../../hooks/usePatientViewerFhirSearch';

export default (tableModuleProps: TableModuleProps): SearchConfig => ({
  dataSource: tableModuleProps.dataSource,
  patientId: _get<fhir.Patient, 'id', string>(
    tableModuleProps.patient,
    'id',
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    null,
  ),
  deviceId: tableModuleProps.deviceId,
  applyDateFilter: tableModuleProps.applyDateFilter,
  dateBounds: tableModuleProps.dateFilter,
  useTagFilter: tableModuleProps.useTagFilter,
  tagFilters: tableModuleProps.filters,
  useNotTagFilter: tableModuleProps.useNotTagFilter,
  notTagFilters: tableModuleProps.notTagFilters,
  pageSize: tableModuleProps.pageSize,
  useCategoryFilter: tableModuleProps.useCategoryFilter,
  categories: tableModuleProps.categories,
  timeFilterProps: tableModuleProps.timeFilterProps,
  observationCodes: tableModuleProps.observationCodes,
  medicationRequestCodes: tableModuleProps.medicationRequestCodes,
  medicationAdministrationCodes: tableModuleProps.medicationAdministrationCodes,
  medicationStatementCodes: tableModuleProps.medicationStatementCodes,
  medicationDispenseCodes: tableModuleProps.medicationDispenseCodes,
  procedureCodes: tableModuleProps.procedureCodes,
  encounterCodes: tableModuleProps.encounterCodes,
  conditionCodes: tableModuleProps.conditionCodes,
  goalCodes: tableModuleProps.goalCodes,
  diagnosticReportCodes: tableModuleProps.diagnosticReportCodes,
  displayAllObservationCodes: tableModuleProps.displayAllObservationCodes,
  displayAllMedicationRequestCodes:
    tableModuleProps.displayAllMedicationRequestCodes,
  displayAllMedicationAdministrationCodes:
    tableModuleProps.displayAllMedicationAdministrationCodes,
  displayAllMedicationStatementCodes:
    tableModuleProps.displayAllMedicationStatementCodes,
  displayAllMedicationDispenseCodes:
    tableModuleProps.displayAllMedicationDispenseCodes,
  displayAllProcedureCodes: tableModuleProps.displayAllProcedureCodes,
  displayAllEncounterCodes: tableModuleProps.displayAllEncounterCodes,
  displayAllConditionCodes: tableModuleProps.displayAllConditionCodes,
  displayAllDiagnosticReportCodes:
    tableModuleProps.displayAllDiagnosticReportCodes,
  displayAllGoalCodes: tableModuleProps.displayAllGoalCodes,
});
